/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/react-in-jsx-scope */
import {
  ALL_TSHIRT_SIZES,
  EVENT_SHIRT_OPTIONS,
  TSHIRT_SIZES,
} from '../../../constants/models'
import FormSelectInput from '../elements/FormSelectInput'

interface ShirtFieldInputsProps {
  key: number
  fullShirtDetails: any
  formDisabled?: boolean
  sizeMd?: number
}

/**
 * Shared shirt type and size select inputs.
 * Used by ParticipantFormContent, IndividualUserFormContent, and category/content.
 */
const shirtFieldInputs = ({
  key,
  fullShirtDetails,
  formDisabled,
  sizeMd = 6,
}: ShirtFieldInputsProps) => [
  {
    ...((key === 1 || (key === 2 && fullShirtDetails.hasShirt2)) &&
      fullShirtDetails.shirtDetails &&
      `SHIRT${key}` in fullShirtDetails.shirtDetails &&
      fullShirtDetails.shirtDetails[`SHIRT${key}`] &&
      'TYPE_OPTIONS' in fullShirtDetails.shirtDetails[`SHIRT${key}`] && {
        id: `${key > 1 ? `shirtType${key}` : 'shirtType'}`,
        size: { sm: 12, md: sizeMd },
        field: (
          <FormSelectInput
            name={`${key > 1 ? `shirtType${key}` : 'shirtType'}`}
            label={`${
              fullShirtDetails.shirtDetails[`SHIRT${key}`].LABEL || 'Shirt'
            }`}
            autoComplete={`${
              key > 1 ? `new-shirtType${key}` : 'new-shirtType'
            }`}
            placeholder={`Select ${
              fullShirtDetails.shirtDetails[`SHIRT${key}`].LABEL || 'Shirt'
            }`}
            disabled={formDisabled}
            options={(
              fullShirtDetails.shirtDetails[`SHIRT${key}`].TYPE_OPTIONS ||
              EVENT_SHIRT_OPTIONS
            ).map((key: string) => ({
              value: key,
              text: key,
            }))}
            required
          />
        ),
      }),
  },
  {
    ...((key === 1 || (key === 2 && fullShirtDetails.hasShirt2)) && {
      id: `${key > 1 ? `shirtSize${key}` : 'shirtSize'}`,
      size: { sm: 12, md: sizeMd },
      field: (
        <FormSelectInput
          name={`${key > 1 ? `shirtSize${key}` : 'shirtSize'}`}
          label={`${
            fullShirtDetails.shirtDetails[`SHIRT${key}`].LABEL || 'Shirt'
          } size`}
          autoComplete={`${key > 1 ? `new-shirtSize${key}` : 'new-shirtSize'}`}
          placeholder={`Select ${
            fullShirtDetails.shirtDetails[`SHIRT${key}`].LABEL || 'Shirt'
          } Size`}
          disabled={formDisabled}
          options={
            fullShirtDetails.shirtDetails &&
            `SHIRT${key}` in fullShirtDetails.shirtDetails &&
            fullShirtDetails.shirtDetails[`SHIRT${key}`] &&
            'SIZE_OPTIONS' in fullShirtDetails.shirtDetails[`SHIRT${key}`]
              ? fullShirtDetails.shirtDetails[`SHIRT${key}`].SIZE_OPTIONS.map(
                  (value: string) => ({
                    value,
                    text: ALL_TSHIRT_SIZES[value],
                  }),
                )
              : Object.entries(TSHIRT_SIZES).map(([key, value]) => ({
                  value: key,
                  text: value,
                }))
          }
          required
        />
      ),
    }),
  },
]

export default shirtFieldInputs
